import React from 'react';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Aceptar',
  cancelText = 'Cancelar',
  type = 'default',
  isLoading = false,
}) => {
  if (!isOpen) return null;

  const confirmButtonClass =
    type === 'danger'
      ? 'bg-red-600 hover:bg-red-700'
      : 'bg-teal-600 hover:bg-teal-700';

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={isLoading ? undefined : onClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === 'Enter') e.preventDefault();
        }}
        role="dialog"
        aria-modal="true"
      >
        <div className="p-6">
          {type === 'danger' && (
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100 mb-4">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
              </svg>
            </div>
          )}
          {title && (
            <h3 className={`text-lg font-semibold text-gray-900 mb-2 ${type === 'danger' ? 'text-center' : ''}`}>
              {title}
            </h3>
          )}
          <div className={`text-gray-600 mb-6 text-sm leading-relaxed ${type === 'danger' ? 'text-center' : ''}`}>
            {message}
          </div>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={isLoading}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {cancelText}
            </button>
            <button
              type="button"
              disabled={isLoading}
              onClick={async () => {
                try {
                  const ret = onConfirm();
                  if (ret != null && typeof ret.then === 'function') {
                    await ret;
                  }
                  onClose();
                } catch {
                  // Mantener el modal abierto si la acción falló.
                }
              }}
              className={`px-4 py-2 text-sm font-medium text-white rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${confirmButtonClass}`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
